import { API } from "@swivl-mono/api-helper";
import { UnitInterface } from "@swivl-mono/types";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

interface StoreInterface {
  unitsByLocation?: { [locationId: number]: UnitInterface[] };
}
const BlankState: StoreInterface = {
  unitsByLocation: undefined,
};

export class UnitsModel {
  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  private static setState = UnitsModel.useState.setState;
  static get state() {
    return UnitsModel.useState.getState();
  }
  static reset() {
    UnitsModel.setState({ ...BlankState });
  }
  static isLoading = false;

  static async getUnitsByLocation(locationId: number, force = false) {
    if (!force && UnitsModel.state.unitsByLocation?.[locationId]) {
      return;
    }

    this.isLoading = true;

    const units = await API.Units.getUnitsByLocationId(Member.orgId, locationId);
    if (!units) {
      return;
    }
    const unitsByLocation = UnitsModel.state.unitsByLocation || {};
    unitsByLocation[locationId] = units;
    UnitsModel.setState({ unitsByLocation });

    this.isLoading = false;
  }
}
